import React, { useState } from 'react';
import styled from 'styled-components';
import { ChevronDown } from 'lucide-react';
import colors from 'theme/colors';
import { Section, SectionInner, Eyebrow, SectionTitle, campaign } from './shared';

const FAQ = [
    {
        q: 'Quem já é produtor Whizr também entra no desconto?',
        a: 'Sim. A condição especial vale tanto pra quem já vende com a gente quanto pra quem cria uma conta nova — o único critério é o evento ter sido criado entre 1º de setembro e 30 de novembro.',
    },
    {
        q: 'Preciso fazer algo além de criar o evento no período?',
        a: 'Não. A taxa reduzida (6% no Pix e 8% no cartão) já sai aplicada automaticamente nas vendas de qualquer evento criado dentro da campanha.',
    },
    {
        q: 'Depois dos 3 meses, a taxa volta ao normal?',
        a: 'Sim. A condição especial vale por 3 meses a partir da criação do evento; depois desse período, a taxa padrão da plataforma volta a valer.',
    },
    {
        q: 'Como funciona o programa de afiliados?',
        a: 'Todo produtor e estabelecimento tem um link de indicação próprio. Ao indicar um produtor, você ganha 1% sobre os 3 primeiros eventos dele em até 1 ano; ao indicar um estabelecimento, 30% (única vez) sobre a primeira assinatura de plano, em até 3 meses.',
    },
];

export default function FaqSection() {
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <Section>
            <SectionInner>
                <Eyebrow>Dúvidas rápidas</Eyebrow>
                <SectionTitle>Perguntas frequentes</SectionTitle>

                <List>
                    {FAQ.map(({ q, a }, i) => {
                        const isOpen = openIndex === i;
                        return (
                            <Item key={i} $open={isOpen}>
                                <Question $open={isOpen} onClick={() => setOpenIndex(isOpen ? -1 : i)}>
                                    <span>{q}</span>
                                    <ChevronDown size={18} />
                                </Question>
                                {isOpen && <Answer>{a}</Answer>}
                            </Item>
                        );
                    })}
                </List>
            </SectionInner>
        </Section>
    );
}

const List = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 32px;
`;

const Item = styled.div`
    border: 1px solid ${({ $open }) => $open ? campaign.purple : `${colors.night}1a`};
    border-radius: 14px;
    padding: 18px 20px;
    background: #fff;
    transition: border-color 0.15s ease;
`;

const Question = styled.button`
    all: unset;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    cursor: pointer;
    font-size: 15.5px;
    font-weight: 700;
    color: ${colors.nightDark};

    svg {
        flex-shrink: 0;
        transition: transform 0.2s ease;
        transform: rotate(${({ $open }) => $open ? 180 : 0}deg);
    }
`;

const Answer = styled.p`
    margin: 12px 0 0;
    font-size: 14.5px;
    line-height: 1.55;
    color: ${colors.night};
`;
